import React, { Component } from "react";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import {
	AuthButton,
	JsonFetcher,
} from "../components";
import RedirectToLandingPage from '../components/utils/RedirectToLandingPage';
import isAuthenticated from '../utils/auth/isAuthenticated';

export class Home extends Component {
	render() {
		const { is_authenticated } = this.props;

		if (is_authenticated) {
			return <Redirect to={'/leagues'} />;
		}

		if (process.env.NODE_ENV !== 'production') {
			return (
				<React.Fragment>
					<JsonFetcher fetch={['rounds', 'players', 'squads', 'venues']} />
					<AuthButton
						scope="openid email profile offline_access signup"
						btnName="Sign up"
					/>
					<AuthButton scope="openid" btnName="Login" />
				</React.Fragment>
			);
		}
		else {
			return <RedirectToLandingPage />;
		}

	}
}

const mapStateToProps = state => ({
	is_authenticated: isAuthenticated()
});

export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/pages/Home.js